import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import DefaultLayoutV3 from '../layout/DefaultLayoutV3';
import { ManageWorkspacePermissions } from '../types/workspaceTypes';
import { ProtectLazyLoadRoute } from './LazyLoadElement';

const MyProfilePage = lazy(() => import('../pages/Profile/MyProfile'));

// Rendered as a component (not inline JSX in the route array) so
// `DefaultLayoutV3.Content` is read at render, not at module eval. Inline, the
// compound access runs when this top-level array is built, and under the
// bundled build's circular init order `DefaultLayoutV3` is still undefined —
// crashing Storybook/Chromatic story extraction. Keep the access lazy.
const EmbedMyProfileRoute = () => (
  <DefaultLayoutV3.Content>
    {ProtectLazyLoadRoute(MyProfilePage)}
  </DefaultLayoutV3.Content>
);

export const EmbedRoutes: RouteObject[] = [
  {
    element: ProtectLazyLoadRoute(lazy(() => import('../layout/EmbedLayout'))),
    loader: () => {
      return {
        permissionRequired: [PermissionEnum.ViewWorkspace],
      };
    },
    children: [
      {
        path: ':workspaceId',
        children: [
          {
            path: 'manage-workspace',
            element: ProtectLazyLoadRoute(
              lazy(() => import('../layout/ManageWorkspaceTabLayout')),
            ),
            loader: () => ({
              permissionRequired: ManageWorkspacePermissions,
              title: 'Settings',
            }),
            children: [
              {
                index: true,
                element: <Navigate replace to="details" />,
              },
              {
                path: 'details',
                element: ProtectLazyLoadRoute(
                  lazy(
                    () => import('../pages/Workspace/ManageWorkspace/Details'),
                  ),
                ),
                loader: () => ({
                  permissionRequired: [PermissionEnum.EditWorkspaceDetails],
                }),
              },
              {
                path: 'bank-account',
                element: ProtectLazyLoadRoute(
                  lazy(
                    () =>
                      import('../pages/Workspace/ManageWorkspace/BankAccountV2'),
                  ),
                ),
                loader: () => ({
                  permissionRequired: [PermissionEnum.EditBankDetails],
                }),
              },
              {
                path: 'teammates',
                element: ProtectLazyLoadRoute(
                  lazy(
                    () =>
                      import('../pages/Workspace/ManageWorkspace/Teammates'),
                  ),
                ),
                loader: () => ({
                  permissionRequired: [PermissionEnum.EditTeammates],
                }),
              },
            ],
          },
        ],
      },
      {
        path: 'my-profile',
        element: <EmbedMyProfileRoute />,
        loader: () => ({
          title: 'My Profile',
        }),
      },
    ],
  },
];
